// @flow
import React from 'react'
import { connect } from 'react-redux'
import { Grid } from '@material-ui/core'
import { noop } from 'lodash/util'
import i18n from 'i18next'

import { accountActions } from '@modules/account'
import { apiServices } from '@modules/api'
import { checkoutActions } from '@modules/checkout'
import { routerActions } from '@modules/router'
import getMultiLanguagesPaths from '../../master/i18n/translations/multiLanguagesPaths'
import Helmet from '../../master/components/Helmet'
import Navbar from '../../master/components/Navbar'
import Wrapper from '../../master/components/Wrapper'
import { trackPageView } from '../../master/analytics'
import Steps from '../components/Steps'
import Summary from '../components/Summary'
import DeliveryEstimated from './components/DeliveryEstimated'
import PaymentMethod from './components/PaymentMethod'

import { FormWrapper, TitleBox } from './styles'

const mapStateToProps = (state: Object) => ({
  cart: state.cart,
  creditCards: state.account.creditCards,
  hasCreditCards: state.account.creditCards.length > 0,
  isFetchingCheckoutPayment: apiServices.selectFetching(
    state,
    ...[
      checkoutActions.POST_PAYMENT_CREDIT_CARD,
      checkoutActions.POST_PAYMENT_RECURRENT
    ]
  )
})

export const mapDispatchToProps = (dispatch: Function) => ({
  fetchAccount: () => dispatch(accountActions.fetchAccount()),
  navigateTo: (to: string) => dispatch(routerActions.navigateTo(to)),
  postPaymentCreditCard: (options: Object, route: string) => {
    return dispatch(checkoutActions.postPaymentCreditCard(options, route))
  },
  postPaymentRecurrent: (creditCard: number, route: string) => {
    return dispatch(checkoutActions.postPaymentRecurrent(creditCard, route))
  }
})

type Props = {
  fetchAccount: Function,
  cart: Object,
  creditCards: Array<Object>,
  hasCreditCards: boolean,
  isFetchingCheckoutPayment: boolean,
  navigateTo: Function,
  postPaymentCreditCard: Function,
  postPaymentRecurrent: Function
}

export class PaymentContainer extends React.Component<Props> {
  componentDidMount () {
    if (!this.props.cart.products.length || !this.props.cart.delivery.slotID) {
      this.props.navigateTo(i18n.t('routes.CHECKOUT_REVIEW'))
    }

    this.props.fetchAccount()

    if (window.dataLayer) {
      trackPageView()

      return
    }

    window.onload = () => trackPageView()
  }

  render () {
    const URLComponents = { path: 'routes.CHECKOUT_PAYMENT' }
    return (
      <>
        <Helmet multiLanguagesPaths={getMultiLanguagesPaths(URLComponents)} />
        <Navbar multiLanguagesPaths={getMultiLanguagesPaths(URLComponents)} />
        <Wrapper>
          <Grid container spacing={16}>
            <Steps activeStep={3} />
            <Grid item xs={12} sm={8}>
              <TitleBox>{i18n.t('checkout.paymentMethod')}</TitleBox>
              <FormWrapper>
                <PaymentMethod
                  creditCards={this.props.creditCards}
                  isFetchingCheckoutPayment={
                    this.props.isFetchingCheckoutPayment
                  }
                  postPaymentRecurrent={this.props.postPaymentRecurrent}
                  postPaymentCreditCard={this.props.postPaymentCreditCard}
                  hasCreditCards={this.props.hasCreditCards}
                >
                  <DeliveryEstimated
                    date={this.props.cart.delivery.date}
                    language={i18n.language}
                  />
                </PaymentMethod>
              </FormWrapper>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Summary
                products={this.props.cart.products}
                showCart
                showNextStepButton={false}
                total={this.props.cart.total}
                totalDiscounts={this.props.cart.order.totalDiscounts}
                totalProducts={this.props.cart.order.totalProducts}
                totalShipping={this.props.cart.order.totalShipping}
                onNextStepClick={noop}
              />
            </Grid>
          </Grid>
        </Wrapper>
      </>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentContainer)
